import { CommitmentsDeathService_deathServiceGetClaimsFrame } from '@festina/life-general-types/life/hooks/CommitmentsDeathService_deathServiceGetClaimsFrame'

export const useFetchDeathClaimsFrameNoSuspense =
  CommitmentsDeathService_deathServiceGetClaimsFrame.useQuery
